import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../../shared/button/Btn"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect } from "react"
import PageTopTitle from "../../shared/PageTopTitle"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 500px;
        height: 300px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        border-radius: 10px;
        padding-block: 20px;
        .content{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .btn-container{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 20px;
            }
        }
    }

`

const AdminDriverJobSeekerOptionsModal = () => {

    const {modalLocation } = useSelector(state => state.modal)
    const {selectRentalCar } = useSelector(state => state.ilanlar)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])


  return (
    <Container onClick={() => dispatch(showModal(null)) }>
        <div className="modal" onClick={(e)=>{e.stopPropagation(); dispatch(handleActiveSelect(null))}} >
            <PageTopTitle isDiffPage title={"Kiralık Araç Ayarlar"}/>
            <div className="content">
                <div className="btn-container">
                    <Button width="200px" handleClick={() => dispatch(showModal("adminDriverJobSeekerUpdate"))} padding="10px" background="#fff" color={"#E85446"}>İlanı Güncelle</Button>
                    <Button width="200px" handleClick={() => dispatch(showModal("adminDriverJobSeekerDelete"))} padding="10px" background="#fff" color={"#E85446"}>İlanı Sil</Button>
                    <Button width="200px" handleClick={() => dispatch(showModal(null))} padding="10px" background="#fff" color={"#E85446"}>Kapat</Button>
                </div>
            </div>
        </div>
    </Container>
  )
}

export default AdminDriverJobSeekerOptionsModal